import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import { OpeningHoursInput } from "../OpeningHoursInput/OpeningHoursInput";
import type { MerchantFacilityHoursDto } from "Infrastructure/Api/Api";

type Props<FormType extends FieldValues> = {
  name: FieldPath<FormType>;
  control: Control<FormType, object>;
  label?: string;
};

export const OpeningHoursFormInput = <T extends FieldValues>({
  name,
  control,
  label,
}: Props<T>) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value }, fieldState: { error } }) => (
      <OpeningHoursInput
        label={label}
        onChange={onChange}
        errorMessage={error?.message}
        value={(value as Array<MerchantFacilityHoursDto>) ?? []}
      />
    )}
  />
);
